export default function AttachMenu({ showMenu, onFileUpload, onVideoMode, onClose }) {
  if (!showMenu) return null

  return (
    <div className="absolute bottom-full left-0 mb-2 bg-white border border-gray-200 rounded-xl shadow-lg p-2 min-w-48">
      <button
        onClick={() => {
          onFileUpload()
          onClose()
        }}
        className="w-full flex items-center gap-3 p-3 text-left hover:bg-gray-50 rounded-lg transition-colors"
      >
        <div className="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-blue-600">
            <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
            <circle cx="9" cy="9" r="2"/>
            <path d="M21 15l-3.086-3.086a2 2 0 0 0-2.828 0L6 21"/>
          </svg>
        </div>
        <div>
          <div className="font-medium text-gray-900">Upload Photo</div>
          <div className="text-sm text-gray-600">Analyze images</div>
        </div>
      </button>
      
      <button
        onClick={() => {
          onVideoMode()
          onClose()
        }}
        className="w-full flex items-center gap-3 p-3 text-left hover:bg-gray-50 rounded-lg transition-colors"
      >
        <div className="w-8 h-8 bg-red-100 rounded-lg flex items-center justify-center">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-red-600">
            <path d="M23 7l-7 5 7 5V7z"/>
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
          </svg>
        </div>
        <div>
          <div className="font-medium text-gray-900">Live Video</div>
          <div className="text-sm text-gray-600">Real-time inspection</div>
        </div>
      </button>
    </div>
  )
}
